// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RowsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RowsIcon" ref={forwardedRef} {...props}>
      <path d="M3 16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm1.5-.5v-2.626h11V15.5zm11-6.876v2.75h-11v-2.75zm0-1.5h-11V4.5h11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RowsIcon = /* @__PURE__ */ Object.assign(RowsIconComponent, {
  displayName: 'RowsIcon',
});
